export default __webpack_public_path__ + "static/media/ohoskin-1.8c93dc16.mp4";